import styles from './Header.module.scss';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import React, { useState } from 'react';
import { ReactComponent as Colapse } from 'assets/colapse.svg';
import { observer } from 'mobx-react';
import useWindowSize from 'hooks/useWindowSize';
import { store } from 'stores/Store';
import { formatCurrency } from 'helpers';
import useExternalApiService from 'helpers/ExternalApiService';
import Text from 'components/Text/Text';
interface IHeader {
  isSidepaneOpen: boolean
  toggleSidePane: () => void
}
const Header: React.FC<IHeader> = observer(({ isSidepaneOpen, toggleSidePane }) => {
  
  const { loadPractitionerGoals, loadFMCInfo } = useExternalApiService(process.env.REACT_APP_EAI_URL);

  const location = useLocation();
  const [showGoal, setShowGoal] = useState(true);
  const { width } = useWindowSize();

  const user = 'Clarence cjlee@eisengard.ai';
  const isWinback = () => {
    if (location.pathname.includes('winback'))
      return true
    return false
  }
  
  React.useEffect(() => {
    if (store.impersonatedUser) {
      loadPractitionerGoals();
      loadFMCInfo(); 
    }
  }, [store.impersonatedUser]);

  /*
  const renderGoals = () => {
    if (store.practitionerGoals && store.practitionerGoals.goal) {
      return (
        <>
        <div className={styles.leftValue}>
          <Text color='white' type='big' textAlign='left'>{formatCurrency(store.practitionerGoals?.ytd_sales ?? 0)}</Text>
          <Text color='white' type='smallHeader' textAlign='left'>YTD Revenue</Text>
        </div>
        <div className={styles.rightValue}>
          {width <= 600 ? (
            <div onClick={() => setShowGoal(!showGoal)}>
              {showGoal ? (
                <>
                  <Text color='white' type='big' textAlign='right'>{formatCurrency(store.practitionerGoals?.goal ?? 0)}</Text>
                  <Text color='white' type='smallHeader' textAlign='right'>Annual Goal</Text>
                </>
              ) : (
                <>
                  <Text color='white' type='big' textAlign='right'>{store.practitionerGoals?.goal_percentage.toFixed(2) + '%'}</Text>
                  <Text color='white' type='smallHeader' textAlign='right'>Percent to Goal</Text>
                </>
              )}
            </div>
          ) : (
            <>
              <>
                <Text color='white' type='big' textAlign='right'>{formatCurrency(store.practitionerGoals?.goal ?? 0)}</Text>
                <Text color='white' type='smallHeader' textAlign='right'>Annual Goal</Text>
              </>
              <>
                <Text color='white' type='big' textAlign='right'>{store.practitionerGoals?.goal_percentage.toFixed(2) + '%'}</Text>
                <Text color='white' type='smallHeader' textAlign='right'>Percent to Goal</Text>
              </>
            </>
          )}
        </div>
      </>
      )
    }
  }*/

  const renderGoals = () => {
    const g = store.practitionerGoals;
    if (!g || g.goal == null) return null;

    // pull out your three fields
    const { ytd_sales, goal, goal_percentage } = g;

    // only render at all if we have at least a sales number
    // (or any other business rule you prefer)
    if (ytd_sales == null) return null;

    // helpers for formatting or fallback
    const prettySales  = formatCurrency(ytd_sales);
    const prettyGoal   = goal        != null ? formatCurrency(goal)                    : '–';
    const prettyPct    = goal_percentage != null && Number.isFinite(goal_percentage)
                        ? `${(goal_percentage * 100).toFixed(2)}%`
                        : '–';

    return (
      <>
        <div className={styles.leftValue}>
          <Text color='white' type='big' textAlign='left'>{prettySales}</Text>
          <Text color='white' type='smallHeader' textAlign='left'>YTD Revenue</Text>
        </div>

        <div className={styles.rightValue}>
          {width <= 600 ? (
            <div onClick={() => setShowGoal(!showGoal)}>
              {showGoal ? (
                <>
                  <Text color='white' type='big' textAlign='right'>{prettyGoal}</Text>
                  <Text color='white' type='smallHeader' textAlign='right'>Annual Goal</Text>
                </>
              ) : (
                <>
                  <Text color='white' type='big' textAlign='right'>{prettyPct}</Text>
                  <Text color='white' type='smallHeader' textAlign='right'>Percent to Goal</Text>
                </>
              )}
            </div>
          ) : (
            <>
              <div>
                <Text color='white' type='big' textAlign='right'>{prettyGoal}</Text>
                <Text color='white' type='smallHeader' textAlign='right'>Annual Goal</Text>
              </div>
              <div>
                <Text color='white' type='big' textAlign='right'>{prettyPct}</Text>
                <Text color='white' type='smallHeader' textAlign='right'>Percent to Goal</Text>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  
  return (
    <div className={cx(styles.HeaderWrapper, { [styles.winback]: isWinback() })}>
      <div onClick={toggleSidePane} className={styles.colapseWrapper}>
        <Colapse
          style={{ cursor: 'pointer' }}
          width={28} height={28} />
      </div>
      {(location.pathname !== '/') && (location.pathname !== '/mapView') ?
        
        <>          
        </> :
        renderGoals()
      }
    </div>
  )
})

export default Header
